'use client'
import { PropsWithChildren } from 'react'
import { useTracker } from '../../hooks'

export default function WithTrack(props: PropsWithChildren) {
  useTracker()

  return props.children
}
